


import React from 'react'
import { Header } from '../../Components/header/Header'
import { UserEdit } from '../../Components/UserEdit/UserEdit'

export const UserEditPage = () => {
  return (
    <div className="post-boy">
        <Header/>
        <UserEdit/>
    </div>
  )
}
